import { IActionCategory } from '../components/r3f-components/component-data-structure';

export const getAnalyticsLabelForAction = (actionCategory: IActionCategory, entityName: string): string => {
	switch (actionCategory) {
		case IActionCategory.linkScene:
			return `User tapped on ${entityName}`;
		case IActionCategory.linkSocial:
			return `User tapped on ${entityName}`;
		case IActionCategory.linkPage:
			return `User tapped on ${entityName}`;
		case IActionCategory.playVideo:
			return `User tapped to play ${entityName}`;
		case IActionCategory.animateModel:
			return `User tapped to animated 3D model ${entityName}`;
		case IActionCategory.animateParticle:
			return `User tapped to animated particle ${entityName}`;
		case IActionCategory.dialNumber:
			return `User dialled number`;
		case IActionCategory.composeEmail:
			return `User composed email`;
		case IActionCategory.saveContact:
			return `User saved contact`;
		case IActionCategory.playSound:
			return `User played sound`;
		case IActionCategory.enlarge:
      		return `User enlarged image`;
		case IActionCategory.takePhoto:
      		return `Snapshot taken`;
		case IActionCategory.multiImageScan:
			return `User activated multi-image scan`
    default:
      return '';
	}
};
